import React from 'react';
import {
  FormControl,
  InputLabel,
  MenuItem,
  OutlinedInput,
  Select,
  SelectChangeEvent,
} from '@mui/material';
import { CustomTypography } from './custom-typography';

export interface Props {
  label: string;
  labelCode: string;
  value: string;
  hideAll?: boolean;
  onChange: (value: string) => void;
  options: {
    id: string;
    name: string;
    description?: string;
  }[];
}

export const SingleChoiceSelect: React.FC<Props> = ({ label, labelCode, value, options, hideAll, onChange }) => {
  const handleChange = (event: SelectChangeEvent<string>) => {
    onChange(event.target.value);
  };

  return (
    <FormControl fullWidth size='small'>
      <InputLabel id={`${labelCode}-select-label`}>{label}</InputLabel>
      <Select
        labelId={`${labelCode}-select-label`}
        id={`${labelCode}-select`}
        sx={{
          borderRadius: 1.5,
          '& .MuiInputBase-input': {
            fontSize: '0.85rem',
          },
          '& .MuiInputLabel-root': {
            fontSize: '0.85rem',
          },
        }}
        value={value}
        onChange={handleChange}
        input={
          <OutlinedInput
            label={labelCode}
            sx={{
              fontSize: '0.85rem',
            }}
          />
        }
      >
        {!hideAll && (
          <MenuItem
            value={''}
            sx={{
              fontSize: '0.85rem',
            }}
          >
            All
          </MenuItem>
        )}
        {options?.map(({ id, name, description }) => (
          <MenuItem
            key={id}
            value={id}
            sx={{
              fontSize: '0.85rem',
            }}
          >
            {name} {description && <CustomTypography fontStyle='italic' value={`(${description})`} />}
          </MenuItem>
        ))}
      </Select>
    </FormControl>
  );
};
